// Per-message text direction detector (Sprint 8C — Gal 2026-06-08).
//
// WhatsApp-style: each bubble decides its own direction based on the
// dominant script in the body, independent of the app's global theme
// direction. A Hebrew message in an English-locale UI still renders
// RTL; an English message in a Hebrew-locale UI renders LTR.
//
// Strategy: shallow detection — if the body contains ANY strong RTL
// character (Hebrew, Arabic, Syriac, Thaana, presentation forms),
// treat it as RTL. This matches the user expectation that a message
// with even one Hebrew word "feels" Hebrew. Empty/whitespace-only
// bodies fall back to "ltr" so we don't flip empty captions.
//
// Range references (Unicode escapes used to avoid editor encoding issues):
//   ֐-׿  Hebrew
//   ؀-ۿ  Arabic
//   ܀-ݏ  Syriac
//   ހ-޿  Thaana (Dhivehi)
//   יִ-﷿  Hebrew + Arabic presentation forms-A
//   ﹰ-﻿  Arabic presentation forms-B
const RTL_CHAR =
  /[֐-׿؀-ۿ܀-ݏހ-޿יִ-﷿ﹰ-﻿]/;

/**
 * @param {string} text message body
 * @returns {"rtl" | "ltr"}
 */
export const detectTextDirection = (text) => {
  if (typeof text !== "string" || !text) return "ltr";
  return RTL_CHAR.test(text) ? "rtl" : "ltr";
};

export default detectTextDirection;
